// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__SIrBN","footer":"ModalError_footer__QbODB"};